import CoursesList from './CoursesList';

export default CoursesList;
